import { supabase } from '../services/supabase';

// Fire-and-forget activity logging. Records a meaningful action into activity_log
// which feeds the PB Intelligence Layer (/intelligence). Never blocks or throws
// into the UI, logging failures are swallowed with a console warning.
export async function logActivity(
  profileId: string,
  firmId: string | null,
  actionType: string,
  entityType: string,
  entityId: string,
  metadata: Record<string, any> = {}
) {
  try {
    await supabase.from('activity_log').insert({
      profile_id: profileId,
      firm_id: firmId,
      action_type: actionType,
      entity_type: entityType,
      entity_id: entityId,
      metadata,
    });
  } catch (e) {
    // non-fatal, never block UI for logging
    console.warn('Activity log failed:', e);
  }
}
